<!--<section class="skills-requirement-section dark">
  <p class="title">Habilidades requeridas</p>
  <div class="container">
    <div class="cards" #cardsAnimation>
      <div class="text-container">
        <p>- Puedes escribir código que sea mantenible y extensible y tienes buen dominio de programación orientada a objetos.</p>
        <p>- Programas de forma fluida en .NET usando C# y estas familiarizado con expresiones Lambda, IEnumerables y Generics.</p>
        <p>- Tienes experiencia inicial o intermedia en "Fullstack: React and .NET C#".</p>
      </div>
    </div>
  </div>
</section>-->

<!--<section class="skills-requirement-section dark" id="requirements">
  <div class="content">
    <p class="title">Habilidades requeridas</p>
    <div class="description" #animation>
      <p>- Puedes escribir código que sea mantenible y extensible y tienes buen dominio de programación orientada a objetos.</p>
      <p>- Programas de forma fluida en .NET usando C# y estas familiarizado con expresiones Lambda, IEnumerables y Generics.</p>
      <p>- Tienes experiencia inicial o intermedia en "Fullstack: React and .NET C#".</p>
    </div>
  </div>
</section>-->

<!--<section class="skills-requirement-section" id="requirements">
  <div class="content">
    <p class="title">Habilidades requeridas</p>
    <div class="description" #animation>
      <p>
        - Puedes escribir código que sea mantenible y 
        extensible y tienes buen dominio de programación 
        orientada a objetos.
      </p>
      <p>
        - Programas de forma fluida en .NET usando C# 
        y estas familiarizado con expresiones Lambda, 
        IEnumerables y Generics.
      </p>
      <p>
        - Tienes experiencia inicial o intermedia en "Fullstack: React and .NET C#".
      </p>
    </div>
  </div>
</section>-->


<section class="skills-requirements-section dark">
  <div class="content">
    <p class="title">Habilidades requeridas</p>
    <div class="description rightToLeft">
      <p> - Puedes escribir código que sea mantenible y extensible y tienes buen dominio de programación orientada a objetos. </p>
      <p> - Programas de forma fluida en .NET usando C# y estas familiarizado con expresiones Lambda, IEnumerables y Generics. </p>
      <p> - Tienes experiencia inicial o intermedia en "Fullstack: React and .NET C#" </p>
    </div>
  </div>
</section>